import React from 'react';

const cs2AssistantConversation = (
  <div className="space-y-4">
    {/* 1 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Thank you for taking the time to participate in this interview. I’d like to explore some topics related to human interactions and how they translate to interactions with conversational agents...
        </div>
      </div>
    </div>
    {/* 2 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Social conversations in my daily life often revolve around sharing personal experiences, exchanging ideas, or catching up with friends and family...
        </div>
      </div>
    </div>
    {/* 3 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Thank you for sharing these insights. Your responses provide a deep understanding of how human conversational characteristics could translate to interactions with conversational agents...
        </div>
      </div>
    </div>
    {/* 4 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Recently, a friend and I had a heartfelt conversation about life's challenges and aspirations over coffee...
        </div>
      </div>
    </div>
    {/* 5 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Thank you for providing such rich and comprehensive responses. Your insights are incredibly valuable...
        </div>
      </div>
    </div>
    {/* 6 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          For conversational agents to facilitate emotionally grounding experiences, they would benefit from capabilities to detect and process emotional tones...
        </div>
      </div>
    </div>
  </div>
);

export default cs2AssistantConversation;
